import gql from "graphql-tag";
import graphqlClient from "../../../apollo";

class CountryTablesProvider {
  getDataCountryTableResult(filter) {
    return graphqlClient.query({
      query: gql`
        query performanceToolResult($filter: String!) {
          performanceToolResult(filter: $filter) {
            data
          }
        }
      `,
      variables: {
        filter,
      },
    });
  }

  getDataVulnerability() {
    return graphqlClient.query({
      query: gql`
        query vulnerability {
          vulnerability {
            data
          }
        }
      `,
    });
  }

  getDataPerformance() {
    return graphqlClient.query({
      query: gql`
        query performance {
          performance {
            data
          }
        }
      `,
    });
  }

  setVulnerabilityMutation(appJson) {
    return graphqlClient.mutate({
      mutation: gql`
        mutation vulnerability($appJson: String!) {
          vulnerability(appJson: $appJson) {
            data
          }
        }
      `,
      variables: {
        appJson,
      },
    });
  }

  ApplyExportExcel(variable, data) {
    return graphqlClient.mutate({
      mutation: gql`
        mutation exportExcelVulnerability(
          $variable: [String!]
          $data: String!
        ) {
          exportExcelVulnerability(variables: $variable, data: $data) {
            url
          }
        }
      `,
      variables: {
        variable,
        data,
      },
    });
  }

  setPerformanceMutation(appJson) {
    return graphqlClient.mutate({
      mutation: gql`
        mutation performance($appJson: String!) {
          performance(appJson: $appJson) {
            data
          }
        }
      `,
      variables: {
        appJson,
      },
    });
  }

  ApplyExportExcelPerformance(variable, data) {
    return graphqlClient.mutate({
      mutation: gql`
        mutation exportExcelPerformace($variable: [String!], $data: String!) {
          exportExcelPerformace(variables: $variable, data: $data) {
            url
          }
        }
      `,
      variables: {
        variable,
        data,
      },
    });
  }
}

export default new CountryTablesProvider();
